import React, { useContext } from 'react';
import { Field } from "formik";
import { GlobalAuthContext } from 'store/context';
import MasksHelper from 'utils/src/masks';
import Colors from "constants/Colors";
import { Label, CheckBox, Button, HasPermission, InputField } from '@fitinsur/components';
import Icon from 'components/Icon';
import { SelectField } from "../Form";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  SmallTitle,
  TableColumn,
  InlineLabel,
  TitleAlter,
  TableColumnCoverageItem,
  RowValue
} from './styles';
import './styles.css';

const SingleProductPlan = ({
  props: {
    calcList,
    history,
    idOperation,
    idProduct,
    formikValues,
    disabled,
    permissions,
    onRecalculate,
    handleCheckCoverage,
    onRecalculateItem,
    onConfirmPlanText,
    onConfirmPlan,
    disabledCommision,
    selectedOption,
    openHistoryModel,
    disabledConfirm,
    readOnlyMode,
    showHistory,
    showCoveragesAndExtensions,
    onOptionsDeductible,
    onSelectDeductible,
    onChoosedDeductible,
    hasCoverageCalc,
    showAlterButton,
    minComission,
    maxComission,
    isInAnalysis,
    newDisabled,
    enableLmiAndSublimit,
    idDomainOperation
  },
  productPlanName,
  coverage,
  option,
  showOption,
  parseNumber,
  // currencyMask,
  expanded
}) => {
  const maskHelper = new MasksHelper();
  const authContext = useContext(GlobalAuthContext);
  const formikKey = readOnlyMode ? 'previousCalculationList' : 'calculationList';

  const handleIcons = (index, covIndex) => formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ? <Icon name='close-red' /> : <Icon name='check' />

  const HAS_APPROVAL_AND_REJECT_PERMISSION = idDomainOperation === 26 ? permissions.NBI_REQUEST_APPROVE_REJECT : permissions.ENDORSEMENT_APPROVE_REJECT;

  const getLmiDisabled = () => {
    return (enableLmiAndSublimit && !isInAnalysis) ? false : (readOnlyMode || !HAS_APPROVAL_AND_REJECT_PERMISSION || disabled);
  }

  const getSublimitDisabled = () => {
    return (enableLmiAndSublimit && !isInAnalysis) ? false : (readOnlyMode || !HAS_APPROVAL_AND_REJECT_PERMISSION || disabled);
  }

  const currencyMask = (maxValue) => ({
    "type": "currency",
    "mask": 0,
    "scale": 2,
    "signed": true,
    "normalizeZeros": false,
    "padFractionalZeros": true,
    "radix": ",",
    "thousandsSeparator": ".",
    "mapToRadix": [
      ".",
      ","
    ],
    "max": maxValue || 999999999999999,
    // "min": 0
  })

  return (
    <>
      <TableComponent>
        <TableHead>
          <TableRow>
            {(hasCoverageCalc && onOptionsDeductible.length && idProduct == 9004) ? (
              <>
                <TableHeader>
                  <SmallTitle>Selecione a franquia:</SmallTitle>
                </TableHeader>
                <TableHeader style={{ paddingBottom: '20px' }} colSpan={'100%'}>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1px' }}>
                    <Field
                      style={{ width: '100%', margin: 'auto' }}
                      component={SelectField}
                      disabled={(idDomainOperation !== 26 && !permissions?.ENDORSEMENT_APPROVE_REJECT) || (readOnlyMode || disabledCommision)}
                      options={onOptionsDeductible}
                      name='optionDeductible'
                      value={formikValues.optionDeductible}
                      placeholder='Selecione a franquia'
                      hidePlaceholder
                      onChange={value => onSelectDeductible && onSelectDeductible(value)}
                    />
                  </div>
                </TableHeader>
              </>
            ) : <></>}
          </TableRow>
          <TableRow>
            <TableHeader className={'empty-th'} width={300} />
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              return (
                <TableHeader
                  colSpan={idProduct == 9004 ? 14 : 5}
                  style={{
                    textAlign: 'center',
                    color: Colors.WHITE,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                  backgroundColor={Colors.PRIMARY1}
                  onClick={(e) => {
                    if (selectedOption != null) return;
                    // if (isInAnalysis) return;
                    e.stopPropagation();
                    showOption(index)
                  }}
                >
                  <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ flexGrow: 1, textAlign: 'center', marginLeft: '15px' }}>Opção {index + 1}</span>
                    <HasPermission permission={!readOnlyMode}>
                      {(showHistory)
                        ? <Icon name="icon-green_exclamation" className={'icon-green_exclamation'} style={{ textAlign: 'right', marginRight: '15px' }}
                          onClick={(e) => {
                            if (selectedOption != null) return;
                            e.stopPropagation();
                            openHistoryModel && openHistoryModel(index)
                          }} />
                        : <></>}
                      <Icon name="icon-arrow-right-white" className={expanded ? 'icon-arrow-left-white' : 'icon-arrow-right-white'} style={{ textAlign: 'right', marginRight: '15px' }} />
                    </HasPermission>
                  </span>
                </TableHeader>
              )
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow backgroundColor={Colors.GRAY[4]}>
            <TableColumn style={{ borderTopLeftRadius: 12, borderTopRightRadius: 12 }} width={100}>
              <SmallTitle>
                Importância Segurada
                {!showAlterButton && <TitleAlter onClick={() => { history.push(`/edit-enquiry/${idProduct}/${idOperation}`, { isEdit: true }) }}>Alterar</TitleAlter>}
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <>
                  <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center >
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label weight={700}>R$ {maskHelper.formatCurrency(authContext, coverageCalc.coverageLimit)}</Label>
                  </TableColumn>
                </>
              )
            })}
          </TableRow>

          {(hasCoverageCalc && idProduct == 9004) && (
            <TableRow>
              <TableColumn width={100}>
                <SmallTitle>
                  Franquia
                </SmallTitle>
              </TableColumn>
              {calcList.map((calculations, index) => {
                if (option != null && index != option) return <></>
                const coverageCalc = calculations
                return (
                  <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center>
                    <InlineLabel>
                      Opção {index + 1}
                    </InlineLabel>
                    <Label>
                      {formikValues?.calculationList[index].coverageItems[0]?.deductibleDescription}
                    </Label>
                  </TableColumn>
                )
              })}
            </TableRow>
          )}

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Prêmio NET
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>
                  <Label>
                    R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmountDiscountLess))}
                  </Label>
                </TableColumn>
              )
            })}
          </TableRow>

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Prêmio Líquido
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>
                  <Label>
                    R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmountTaxLess))}
                  </Label>
                </TableColumn>
              )
            })}
          </TableRow>

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Prêmio Total (valor a ser pago)
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>
                  <Label>
                    R$ {maskHelper.formatCurrency(authContext, parseNumber(coverageCalc.coverageAmount))}
                  </Label>
                </TableColumn>
              )
            })}
          </TableRow>

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Comissão
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>

                  <Field style={{ width: '180px', margin: 'auto' }}
                    name={`${formikKey}.${index}.coverageComissionRate`}
                    component={InputField}
                    disabled={(idDomainOperation !== 26 && !permissions?.ENDORSEMENT_APPROVE_REJECT) || (readOnlyMode || disabledCommision) || (!minComission && !maxComission)}
                    type="text"
                    alignCenter
                    mask={{
                      type: "percentage",
                      mask: '% num',
                      blocks: {
                        num: {
                          mask: Number,
                          scale: 5,
                          signed: false,
                          thousandsSeparator: '',
                          padFractionalZeros: true,
                          normalizeZeros: false,
                          radix: ".",
                          max: maxComission || 100,
                          min: minComission || 0
                        }
                      }
                    }}
                    onBlur={(value) => onRecalculate && onRecalculate(value / 100, index, 'customComissionRate')}
                  />
                </TableColumn>
              )
            })}
          </TableRow>

          <TableRow>
            <TableColumn width={100}>
              <SmallTitle>
                Coberturas
              </SmallTitle>
            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              const coverageCalc = calculations
              return (
                <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center>
                  <InlineLabel>
                    Opção {index + 1}
                  </InlineLabel>
                  {!readOnlyMode && <Button
                    disabled={disabledConfirm}
                    id="btnContinue"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      onConfirmPlan && onConfirmPlan(index)
                    }}
                    style={{ marginLeft: 'auto', marginRight: 'auto' }}
                    primary
                  >
                    {onConfirmPlanText}
                  </Button>}
                </TableColumn>
              )
            })}
          </TableRow>


          <TableRow>
            <TableColumnCoverageItem width={100}>
              <SmallTitle>
                {productPlanName}
              </SmallTitle>
            </TableColumnCoverageItem>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              return (
                <>
                  {(!showCoveragesAndExtensions) ?
                    <>
                      <TableColumnCoverageItem className={'td-coverage'} colSpan={index === option ? 1 : idProduct == 9004 ? 14 : 5} width={100} noBorder={expanded ? true : false} rightBorder={expanded ? true : false}>
                        <SmallTitle></SmallTitle>
                      </TableColumnCoverageItem>
                    </>
                    :
                    <>
                      <TableColumnCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={100} noBorder={expanded ? true : false} rightBorder={expanded ? true : false}>
                        <SmallTitle>
                          LMI
                        </SmallTitle>
                      </TableColumnCoverageItem>
                      <TableColumnCoverageItem className={'td-coverage'} colSpan={index === option ? 1 : idProduct == 9004 ? 14 : 5} width={100} noBorder={index === option ? true :expanded ? true : false}>
                        <SmallTitle>
                          PR. LÍQUIDO
                        </SmallTitle>
                      </TableColumnCoverageItem>
                      <TableColumnCoverageItem className={'td-coverage'} style={{ display: HAS_APPROVAL_AND_REJECT_PERMISSION && index === option ? 'table-cell' : 'none' }} width={100} noBorder={true}>
                        <SmallTitle>
                          PR. TÉCNICO
                        </SmallTitle>
                      </TableColumnCoverageItem>
                      {/* <TableColumnCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={50} noBorder={true}>
                        <SmallTitle>
                          % <br />AJUSTE
                        </SmallTitle>
                      </TableColumnCoverageItem> */}
                      {/* <TableColumnCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={100} noBorder={true}>
                        <SmallTitle>
                          PR. TÉCNICO AJUSTADO
                        </SmallTitle>
                      </TableColumnCoverageItem> */}
                      <TableColumnCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={120} noBorder={true}>
                        <SmallTitle>
                          SUBLIMITE
                        </SmallTitle>
                      </TableColumnCoverageItem>
                      <HasPermission permission={idProduct == 9004}>
                        <TableColumnCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={140} noBorder={true}>
                          <SmallTitle>
                            FRANQUIA
                          </SmallTitle>
                        </TableColumnCoverageItem>
                      </HasPermission>
                      <HasPermission permission={idProduct == 9004}>
                        <TableColumnCoverageItem className={'td-coverage'} style={{ display: index === option ? 'table-cell' : 'none' }} width={80} noBorder={true}>
                          <SmallTitle>
                            LIMITE AGREGADO
                          </SmallTitle>
                        </TableColumnCoverageItem>
                      </HasPermission>
                    </>
                  }
                </>
              )
            })}
          </TableRow>


          {coverage.map((coverages, covIndex) => {
            const validation = (coverages.coverageAvoidDisable || coverages.coverageDomain === 1 || readOnlyMode || !HAS_APPROVAL_AND_REJECT_PERMISSION || newDisabled);
            return (
              <TableRow>
                <TableColumnCoverageItem display={'flex'} style={{ textAlign: "left" }}>
                  {option != null && (!formikValues?.calculationList[option].coverageItems[covIndex]?.coverageRemoved && <Field
                    component={CheckBox}
                    name={`${formikKey}.${option}.coverageItems.${covIndex}.coverageDisabled`}
                    checked={!coverages.coverageDisabled}
                    checkValue
                    // disabled={(!isInAnalysis && coverages.coverageDomain !== 1) ? false : validation}
                    disabled={coverages.coverageRemoved || coverages.coverageAvoidDisable || ((!isInAnalysis) ? coverages.coverageDomain === 1 : validation)}
                    reverseValue
                    onChange={(value) => {
                      handleCheckCoverage && handleCheckCoverage(value, option, coverages.idCoverage)
                    }} />)}
                    {option != null && (formikValues?.calculationList[option].coverageItems[covIndex]?.coverageRemoved && <Field
                      component={CheckBox}
                      name={'defaultValueCoverageRemoved'}
                      checked={false}
                      checkValue
                      disabled={true}
                      />)}
                  <Label>{coverages.coverageName}</Label>
                </TableColumnCoverageItem>

                {calcList.map((calculations, index) => {
                  if (option != null && index != option) return <></>
                  return (
                    <>
                      {(!showCoveragesAndExtensions) ?
                        <TableColumnCoverageItem colSpan={index === option ? 1 : idProduct == 9004 ? 14 : 5} width={20} noBorder={expanded ? true : false} rightBorder={expanded ? true : false}>
                          {handleIcons(index, covIndex)}
                        </TableColumnCoverageItem>
                        :
                        <>
                        {index === option && (
                          <TableColumnCoverageItem colSpan={index === option ? 1 : idProduct == 9004 ? 14 : 5} width={20} noBorder={expanded ? true : false} rightBorder={expanded ? true : false}>
                            {/* {(!showCoveragesAndExtensions) && handleIcons(index, covIndex)} */}
                            <>
                            
                              <InlineLabel>
                                LMI {index + 1}
                              </InlineLabel>
                              {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                <Field
                                  style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
                                  name={'defaultValueCoverageDisabled'}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  readOnly={true}
                                /> :
                                <Field
                                  style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
                                  mask={currencyMask((() => {
                                    const guideline = formikValues?.calculationList[index].coverageItems[covIndex]?.coverageMaxLimClaimGuideline;
                                    if (guideline != null && guideline !== '') {
                                      const numValue = Number(guideline);
                                      return !isNaN(numValue) ? numValue : undefined;
                                    }
                                    return undefined;
                                  })())}
                                  name={`${formikKey}.${index}.coverageItems.${covIndex}.coverageLimit`}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={getLmiDisabled() || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                  readOnly={false}
                                  onBlur={(value) => onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'coverageLimit')}
                                />
                              }
                            </>
                          </TableColumnCoverageItem>
                        )}

                          <TableColumnCoverageItem colSpan={index === option ? 1 : idProduct == 9004 ? 14 : 5} width={20} noBorder={index === option ? true :expanded ? true : false} rightBorder={index === option ? false :expanded ? true : false}>
                            {/* {(!showCoveragesAndExtensions) && handleIcons(index, covIndex)} */}
                            <>
                              <InlineLabel>
                                PR. LÍQUIDO {index + 1}
                              </InlineLabel>
                              {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                <Field
                                  style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
                                  name={'defaultValueCoverageDisabled'}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  readOnly={true}
                                /> :
                                <Field
                                  style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
                                  mask={currencyMask()}
                                  name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumTaxLess`}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={readOnlyMode || !HAS_APPROVAL_AND_REJECT_PERMISSION || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                  readOnly={true}
                                />
                              }
                            </>
                          </TableColumnCoverageItem>

                          {HAS_APPROVAL_AND_REJECT_PERMISSION && index === option && (<TableColumnCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              PR. TÉCNICO
                            </InlineLabel>
                            {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                name={'defaultValueCoverageDisabled'}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={true}
                                readOnly={true}
                              /> :
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                mask={currencyMask()}
                                name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremium`}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={readOnlyMode || !HAS_APPROVAL_AND_REJECT_PERMISSION || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                readOnly={true}
                              />
                            }
                          </TableColumnCoverageItem>)}

                          {/* {index === option && (<TableColumnCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              AJUSTE %
                            </InlineLabel>
                            {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                              <Field
                                style={{ width: '100%', marginBottom: '0px', margin: "auto" }}
                                name={'defaultValueCoverageDisabled'}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={true}
                                readOnly={true}
                              /> :
                              <Field
                                style={{ width: '100%', marginBottom: '0px', margin: "auto" }}
                                name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumDiscountRate`}
                                component={InputField}
                                type="text"
                                validation={false}
                                mask={maskHelper.getPercentage(authContext.region, 2, "1000", "-100")}
                                disabled={readOnlyMode || !HAS_APPROVAL_AND_REJECT_PERMISSION || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                onBlur={(value) => onRecalculate && onRecalculate(value / 100, index, 'customCoveragePremiumDiscountRate')}
                              />
                            }
                          </TableColumnCoverageItem>)} */}
                          {/* {index === option && (<TableColumnCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              PR. TÉCNICO AJUSTADO
                            </InlineLabel>
                            {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                name={'defaultValueCoverageDisabled'}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={true}
                                readOnly={true}
                              /> :
                              <Field
                                style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
                                mask={currencyMask()}
                                name={`${formikKey}.${index}.coverageItems.${covIndex}.coveragePremiumDiscountLess`}
                                component={InputField}
                                type="text"
                                validation={false}
                                disabled={readOnlyMode || !HAS_APPROVAL_AND_REJECT_PERMISSION || disabled || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                readOnly={true}
                              />
                            }
                          </TableColumnCoverageItem>)} */}

                          {index === option && (<TableColumnCoverageItem width={20} noBorder={true}>
                            <InlineLabel>
                              SUBLIMITE
                            </InlineLabel>

                            <RowValue>
                              <RowValue style={{ width: '45px', margin: '0', padding: '0', marginRight: '10px' }}>
                                <Label style={{ margin: '0', padding: '0' }}>%</Label>
                                <Field
                                  style={{ padding: '0', margin: "0", paddingLeft: '5px' }}
                                  component={CheckBox}
                                  name={`${formikKey}.${option}.coverageItems.${covIndex}.showCoverageMaxLimClaimRate`}
                                  checked={formikValues?.calculationList[index].coverageItems[covIndex].showCoverageMaxLimClaimRate}
                                  checkValue
                                  disabled={getSublimitDisabled() || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                  onChange={(value) => onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'showCoverageMaxLimClaimRate')}
                                />
                              </RowValue>

                              {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                <Field
                                  style={{ width: '65%', margin: '0' }}
                                  name={'defaultValueCoverageDisabled'}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  readOnly={true}
                                /> : formikValues?.calculationList[index].coverageItems[covIndex].showCoverageMaxLimClaimRate ?
                                  <Field
                                    style={{ width: '65%', margin: '0' }}
                                    name={`${formikKey}.${index}.coverageItems.${covIndex}.coverageMaxLimClaimRate`}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    mask={maskHelper.getPercentage(authContext.region, 2, "100", "0")}
                                    disabled
                                    onBlur={(value) => onRecalculate && onRecalculateItem(value / 100, index, coverages.idCoverage, 'coverageMaxLimClaimRate', 'coverageMaxLimClaim')}
                                  /> :
                                  <Field
                                    style={{ width: '65%', margin: '0' }}
                                    mask={currencyMask(formikValues?.calculationList[index].coverageItems[covIndex].coverageLimit)}
                                    name={`${formikKey}.${index}.coverageItems.${covIndex}.coverageMaxLimClaim`}
                                    component={InputField}
                                    type="text"
                                    validation={false}
                                    disabled
                                    onBlur={(value) => onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'coverageMaxLimClaim', 'coverageMaxLimClaimRate')}
                                  />
                              }
                            </RowValue>
                          </TableColumnCoverageItem>)}

                          <HasPermission permission={idProduct == 9004}>
                            {index === option && (<TableColumnCoverageItem width={140}  noBorder={true}>
                              <InlineLabel>
                                FRANQUIA
                              </InlineLabel>
                              {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                <Field
                                  style={{ width: '80%', marginBottom: '0px', margin: 'auto' }}
                                  name={'defaultValueCoverageDisabled'}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  readOnly={true}
                                /> :
                                <Field
                                  style={{ width: '80%', marginBottom: '0px', margin: 'auto' }}
                                  name={`${formikKey}.${index}.coverageItems.${covIndex}.deductibleDescription`}
                                  component={SelectField}
                                  options={
                                    !coverages.productCoverageDeductibles?.length 
                                    ? [{ 
                                        value: formikValues?.calculationList[index].coverageItems[covIndex]?.deductibleDescription,
                                        label: formikValues?.calculationList[index].coverageItems[covIndex]?.deductibleDescription
                                      }] 
                                    : coverages.productCoverageDeductibles?.map(item => ({ label: item.deductibleDescription, value: item.deductibleDescription }))
                                  }
                                  type="text"
                                  validation={false}
                                  disabled={(idDomainOperation !== 26 && !permissions?.ENDORSEMENT_APPROVE_REJECT) || !coverages.productCoverageDeductibles?.length || getSublimitDisabled() || formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled}
                                  hidePlaceholder
                                  onChange={(value) => {
                                    onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'customDeductibleDescription')
                                  }}
                                />
                              }
                            </TableColumnCoverageItem>)}
                          </HasPermission>

                          <HasPermission permission={idProduct == 9004}>
                            {index === option && (<TableColumnCoverageItem width={80} noBorder={true}>
                              <InlineLabel>
                                LIMITE AGREGADO
                              </InlineLabel>
                              {formikValues?.calculationList[index].coverageItems[covIndex]?.coverageDisabled ?
                                <Field
                                  style={{ width: '80%', marginBottom: '0px', margin: 'auto' }}
                                  name={'defaultValueCoverageDisabled'}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  readOnly={true}
                                /> :
                                <Field
                                  style={{ width: '80%', marginBottom: '0px', margin: 'auto' }}
                                  name={`${formikKey}.${index}.coverageItems.${covIndex}.aggregateLimit`}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  disabled={true}
                                  onBlur={(value) => onRecalculateItem && onRecalculateItem(value, index, coverages.idCoverage, 'customDeductibleDescription')}
                                />
                              }
                            </TableColumnCoverageItem>)}
                          </HasPermission>
                        </>
                      }
                    </>
                  )
                })}
              </TableRow>
            )
          })}


          <TableRow>
            <TableColumn>

            </TableColumn>
            {calcList.map((calculations, index) => {
              if (option != null && index != option) return <></>
              return (
                <TableColumn colSpan={idProduct == 9004 ? 14 : 5} center>
                </TableColumn>
              )
            })}
          </TableRow>

        </TableBody>
      </TableComponent>
    </>
  )
}

export default SingleProductPlan;